import { Component, Input } from '@angular/core';
import { BaseMessageDTO } from '../../../core/models/dto/base-message.dto';
import { ReplyService } from '../../../core/services/ticket/reply.service';
import { NoteService } from '../../../core/services/note.service';
import { TicketDetailsPanelService } from '../../../core/services/ticket-details-panel.service';
import { TranslateModule } from '@ngx-translate/core';
import { TruncatePipe } from '../../../../sb-tools/typescript/pipes/truncate.pipe';

@Component({
    selector: 'app-reply-quote',
    templateUrl: './reply-quote.component.html',
    styleUrls: ['./reply-quote.component.scss'],
    imports: [TranslateModule, TruncatePipe],
})
export class ReplyQuoteComponent {
    @Input() reply: BaseMessageDTO;

    constructor(
        private replyService: ReplyService,
        private noteService: NoteService,
        private ticketDetailsPanelService: TicketDetailsPanelService,
    ) {}

    viewReply(): void {
        this.replyService.wasReplyScrolledToView = false;

        if (this.noteService.referencedReply === this.reply) {
            this.noteService.updateStamp.next();
        } else {
            this.noteService.referencedReply = this.reply;
        }
        this.noteService.isReplyAlreadySelected = false;

        setTimeout(() => {
            this.replyService.scrollToViewReply(this.reply.id, this.ticketDetailsPanelService.currentTicket);
        }, 300);
    }
}
